import { render } from "./CheckoutValuesCard.vue?vue&type=template&id=4037de93&ts=true"
import script from "./CheckoutValuesCard.vue?vue&type=script&lang=ts"
export * from "./CheckoutValuesCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__